<template>
  <div
    v-if="show"
    class="no-data-exists d-flex flex-column justify-content-center align-items-center"
  >
    <p
      id="noContentText"
      class="text-muted m-0"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'NoContent',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'No data exists',
    },
  },
};
</script>

<style lang="scss" scoped>
  .no-data-exists {
    height: 100px;
    font-size: 18px;
  }
</style>